// Typelizer digest 33e3316190e78936eda89b65397ded2c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /incoming_email_items/:incoming_email_item_id/skip */
  create: (
    params: { incomingEmailItemId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/incoming_email_items/:incoming_email_item_id/skip', params, options),
    method: 'post',
  }),
}
